<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    max-width="1250"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="text-h6"
            >{{ selectedTrackedBill.BillNumber }} -
            {{ selectedTrackedBill.ShortTitle }}
          </div>
          <div>Sponsor: {{ selectedTrackedBill.Sponsor }}</div>
          <v-row
            v-if="!selectedTrackedBill.ID > 0 && userViewAgencies.length > 1"
          >
            <v-col sm="12">
              <LuAgency
                label="Owning Agency"
                :items="userViewAgencies"
                v-model="owningAgencyID"
                clearable
              ></LuAgency>
            </v-col>
          </v-row>
          <v-row
            v-if="
              owningAgencyID == 2 ||
              selectedTrackedBill.TrackedBillAgencies.findIndex(
                (a) => a.AgencyID == 2 && a.TrackedBillPermissionID == 1
              ) != -1
            "
          >
            <v-col sm="12">
              <LuPosition
                clearable
                v-model="selectedTrackedBill.PositionID"
              ></LuPosition>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <LuPriority
                clearable
                v-model="selectedTrackedBill.PriorityID"
              ></LuPriority>
            </v-col>
            <v-col sm="6">
              <LuConcern
                clearable
                v-model="selectedTrackedBill.ConcernID"
              ></LuConcern>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                auto-grow
                rows="3"
                label="Synopsis"
                v-model="selectedTrackedBill.Synopsis"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                auto-grow
                rows="3"
                label="Implications"
                v-model="selectedTrackedBill.Pros"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                auto-grow
                rows="3"
                label="Specific Concerns"
                v-model="selectedTrackedBill.Cons"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                auto-grow
                rows="3"
                label="Proposed Changes"
                v-model="selectedTrackedBill.ProposedChanges"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row v-if="filteredLuAgencyDivisions.length > 0">
            <v-col sm="12">
              <LuAgencyDivision
                label="Agency Division"
                v-model="selectedTrackedBill.TrackedBillDivisions"
                :items="filteredLuAgencyDivisions"
                selfKey="TrackedBillId"
                :selfId="selectedTrackedBill.ID"
                relatedItemKey="DivisionId"
                joinItemName="TrackedBillDivision"
              >
                <template
                  v-if="owningAgencies.length > 1"
                  v-slot:selection="{ item, selected, attrs, select }"
                >
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="removeDivision(item)"
                    >{{ item.Agency.Abr }}: {{ item.Description }}</v-chip
                  ></template
                >
                <template
                  v-if="owningAgencies.length > 1"
                  v-slot:item="{ active, item, attrs, on }"
                >
                  <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          {{ item.Description }}
                          <v-spacer></v-spacer>
                          <v-chip text-color="white" color="primary" small>{{
                            item.Agency.Abr
                          }}</v-chip>
                        </v-row>
                      </v-list-item-title></v-list-item-content
                    >
                  </v-list-item>
                </template>
              </LuAgencyDivision>
            </v-col>
          </v-row>
          <v-row v-if="owningAgencyID > 0 && displayNewUsers">
            <v-col sm="12">
              <UserSearch
                label="Agency Contact"
                v-model="selectedTrackedBill.TrackedBillAssignments"
                selfKey="TrackedBillID"
                :selfID="selectedTrackedBill.ID"
                :agencyID="owningAgencyID"
                :roles="[1, 5, 2, 3]"
                relatedItemKey="UserID"
                joinItemName="TrackedBillAssignment"
              ></UserSearch>
            </v-col>
          </v-row>
          <v-row v-if="selectedTrackedBill.ID > 0">
            <v-col sm="12">
              <User
                label="Agency Contact"
                v-model="selectedTrackedBill.TrackedBillAssignments"
                selfKey="TrackedBillID"
                :selfID="selectedTrackedBill.ID"
                :items="availableUsers"
                relatedItemKey="UserID"
                joinItemName="TrackedBillAssignment"
              >
                <template v-slot:item="{ item, index }">
                  <span v-if="item.FirstName && item.LastName">
                    {{ item.FirstName }} {{ item.LastName }}
                  </span>
                  <span v-else>{{ item.Email }}</span>
                  <span class="ml-2">
                    <v-chip
                      small
                      label
                      :color="item.directOverride ? 'accent' : ' primary'"
                      v-if="item.agency"
                      >{{ item.agency.Abr }}

                      <!-- <v-icon class="pl-1" small v-if="item.agencyPerm == 3"
                        >mdi-eye</v-icon
                      >
                      <v-icon class="pl-1" small v-if="item.agencyPerm == 2"
                        >mdi-pencil</v-icon
                      >
                      <v-icon class="pl-1" small v-if="item.agencyPerm == 1"
                        >mdi-check-decagram</v-icon
                      > -->
                    </v-chip>
                  </span>
                  <span class="ml-2">
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 3"
                      label
                      color="secondary"
                      small
                      position="right"
                      icon="mdi-eye"
                      >Viewer</BaseTooltipChip
                    >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 2"
                      label
                      color="secondary"
                      small
                      position="right"
                      icon="mdi-pencil"
                      >Editor</BaseTooltipChip
                    >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 1"
                      label
                      position="right"
                      color="secondary"
                      small
                      icon="mdi-check-decagram"
                      >Owner</BaseTooltipChip
                    >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 5"
                      label
                      position="right"
                      color="secondary"
                      small
                      icon="mdi-check-decagram"
                      >Manager</BaseTooltipChip
                    >
                  </span>
                </template>
              </User>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-textarea
                auto-grow
                rows="2"
                label="Additional Contact"
                v-model="selectedTrackedBill.Contact"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              sm="12"
              v-if="
                selectedTrackedBill.currentUserPermissionID == 1 ||
                selectedTrackedBill.ID == 0
              "
            >
              <v-checkbox
                label="Is Private"
                v-model="selectedTrackedBill.IsPrivate"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="!selectedTrackedBill.IsActive">
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedTrackedBill.IsActive"
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- //: The multiselects will need to have the props updated to the correct values
          We are not able to determine the nested relations for the template generation
          you will also need to load the appropriate lookup component-->
          <!-- <v-row no-gutters>
            <v-col sm="12">
              <LuConcern
                v-model="selectedTrackedBill.ConcernID"
              ></LuConcern>
            </v-col>
          </v-row> -->
          <!-- <v-row no-gutters>
            <v-col sm="12">
              <User
                v-model="selectedTrackedBill.CreatedByID"
              ></User>
            </v-col>
          </v-row> -->
          <!-- <v-row no-gutters>
            <v-col sm="12">
              <LuPriority
                v-model="selectedTrackedBill.PriorityID"
              ></LuPriority>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveTrackedBillDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBill from '@classes/TrackedBill'
import TrackedBillAgency from '@classes/TrackedBillAgency'
import LuConcern from '@components/select/single/LuConcern'
import LuPosition from '@components/select/single/LuPosition'
import LuPriority from '@components/select/single/LuPriority'
import LuAgency from '@components/select/single/LuAgency'
import UserSearch from '@components/select/a-search-multi-join/User'
import User from '@components/select/a-multi-join/User'
import LuAgencyDivision from '@components/select/LuAgencyDivision/LuAgencyDivision-a-multi-join'
import { authMethods, authComputed } from '@state/helpers'

export default {
  components: {
    LuConcern,
    LuPosition,
    LuPriority,
    LuAgency,
    User,
    UserSearch,
    LuAgencyDivision,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedTrackedBill: new TrackedBill(),
    modalText: '',
    owningAgencyID: 0,
    displayNewUsers: true,
  }),
  created() {
    this.loadLuAgencyDivisions()
  },
  watch: {
    owningAgencyID(nval, oval) {
      // console.log(nval)
      this.displayNewUsers = false
      this.selectedTrackedBill.TrackedBillAssignments = []
      this.$nextTick(() => {
        this.displayNewUsers = true
      })
    },
  },
  computed: {
    ...authComputed,
    ...get('trackedBill', ['saving']),
    ...get('luAgencyDivision', ['luAgencyDivisions']),
    owningAgencies() {
      return this.selectedTrackedBill.TrackedBillAgencies.filter(
        (x) => x.TrackedBillPermissionID == 1
      )
        .map((x) => x.Agency)
        .filter((v, i, list) => {
          return list.findIndex((l) => l.ID == v.ID) === i
        })
    },
    filteredLuAgencyDivisions() {
      return this.luAgencyDivisions.filter(
        (x) =>
          x.AgencyId == this.owningAgencyID ||
          this.owningAgencies.findIndex((a) => a.ID == x.AgencyId) > -1
      )
    },
    availableUsers() {
      //note: we need this here for calculating while in the list
      var trackedBill = this.selectedTrackedBill
      if (trackedBill && trackedBill.ID > 0) {
        var users = []
        var permissionOrder = [1, 0, 2, 3, 4]
        var roleOrder = [1, 5, 2, 3, 4]
        if (
          trackedBill.TrackedBillAgencies &&
          trackedBill.TrackedBillAgencies.length > 0
        ) {
          trackedBill.TrackedBillAgencies.forEach((tba) => {
            let agencyPerm = tba.TrackedBillPermissionID
            tba.Agency.UserAgencies.forEach((ua) => {
              let match = users.findIndex((u) => u.ID == ua.UserID)
              var user = ua.User
              var perm =
                roleOrder.indexOf(ua.AgencyRoleID) <
                permissionOrder.indexOf(agencyPerm)
                  ? agencyPerm
                  : ua.AgencyRoleID
              user.TrackedBillPermissionID = perm
              user.agency = tba.Agency
              user.agencyPerm = agencyPerm
              user.userAgencyBillPerm = perm
              user.agencyRole = ua.AgencyRoleID
              // console.log(ua, user, tba, agencyPerm)

              if (match == -1) {
                if (user.TrackedBillPermissionID != 4) {
                  users.push(user)
                }
              } else {
                var prev = users[match]
                if (
                  prev.TrackedBillPermissionID > user.TrackedBillPermissionID
                ) {
                  // console.log(prev, ua, user, tba, agencyPerm)
                  users[match].TrackedBillPermissionID =
                    user.TrackedBillPermissionID
                  users[match].agency = user.Agency
                  users[match].agencyPerm = agencyPerm
                  users[match].userAgencyBillPerm = user.userAgencyBillPerm
                  users[match].agencyRole = user.agencyRole
                }
              }
            })
          })
        }
        if (
          trackedBill.TrackedBillUsers &&
          trackedBill.TrackedBillUsers.length > 0
        ) {
          trackedBill.TrackedBillUsers.forEach((tbu) => {
            let match = users.findIndex((u) => u.ID == tbu.UserID)
            var user = tbu.User
            user.TrackedBillPermissionID = tbu.TrackedBillPermissionID
            if (match == -1) {
              // console.log(user, tbu)
              if (user.TrackedBillPermissionID != 4) {
                users.push(user)
              }
            } else {
              var prev = users[match]
              if (prev.TrackedBillPermissionID > user.TrackedBillPermissionID) {
                // console.log(prev, user, tbu)
                users[match].TrackedBillPermissionID =
                  user.TrackedBillPermissionID
                users[match].directOverride = true
              }
            }
          })
        }
        //console.cyan(users)
        return users
      } else {
        return []
      }
    },
  },

  methods: {
    handleError: call('errors/handleError'),
    ...call('trackedBill', ['saveTrackedBill']),
    loadLuAgencyDivisions: call(
      'luAgencyDivision/loadLuAgencyDivisionsForUser'
    ),
    async validate() {
      this.$refs.form.validate()
    },
    editTrackedBill(entry, lsobill) {
      let agencies = entry.owningAgencies

      this.selectedTrackedBill = new TrackedBill(entry)
      if (lsobill.catchTitle) {
        this.selectedTrackedBill.ShortTitle = lsobill.catchTitle
      }
      if (lsobill.billType) {
        this.selectedTrackedBill.BillType = lsobill.billType
      }
      if (lsobill.sponsor) {
        this.selectedTrackedBill.Sponsor = lsobill.sponsor
      }
      this.modalText = 'Edit Bill Tracker'
      this.dialog = !this.dialog
    },
    addTrackedBill(bill) {
      console.pink(bill)
      var track = {
        BillNumber: bill.bill,
        Year: bill.year,
        SpecialSession: bill.specialSessionValue,
        ShortTitle: bill.catchTitle,
        BillType: bill.billType,
        Sponsor: bill.sponsor,
        LsoBillStatus: bill.billStatus,
        LsoLastAction: bill.lastAction,
        LsoLastActionDate: bill.lastActionDate,
      }
      //if user has only one agency, set that agency to the owning agency
      if (this.userViewAgencies.length == 1) {
        this.owningAgencyID = this.userViewAgencies[0].ID
      }
      this.modalText = 'Add Bill Tracker'
      this.selectedTrackedBill = new TrackedBill(track)
      this.dialog = !this.dialog
    },
    saveTrackedBillDetails() {
      this.validate().then(() => {
        if (this.valid) {
          if (!this.selectedTrackedBill.ID > 0 && this.owningAgencyID > 0) {
            var tba = new TrackedBillAgency({
              AgencyID: this.owningAgencyID,
              TrackedBillPermissionID: 1,
            })
            this.selectedTrackedBill.TrackedBillAgencies.push(tba)
            console.devlog(this.selectedTrackedBill)
            console.devlog(this.selectedTrackedBill.getSaveData())
          }
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveTrackedBill(this.selectedTrackedBill.getSaveData()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedTrackedBill = new TrackedBill()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedTrackedBill = new TrackedBill()
      this.$refs.form.resetValidation()
    },
    removeDivision(item) {
      const index = this.selectedTrackedBill.TrackedBillDivisions.findIndex(
        (x) => x.DivisionId == item.Id
      )
      if (index >= 0)
        this.selectedTrackedBill.TrackedBillDivisions.splice(index, 1)
    },
  },
}
</script>
<style></style>
